import { io } from 'socket.io-client'
import actionTypes from 'constants/actionTypes'
import { selectLoggedIn } from 'selectors/auth'
import { socketConnected, socketConnecting, socketDisconnected } from 'actions/connection'
import type { MiddlewareStoreShape, NextFn } from 'types/adapters'

type RootState = import('types/state').RootState


type SocketState = 'disconnected' | 'connecting' | 'connected'

type SocketClient = {
  on: (event: string, callback: (...args: unknown[]) => void) => void
  disconnect: () => void
}

type SocketAction = {
  type?: string
}

type MiddlewareStore = MiddlewareStoreShape<RootState>


let socket: SocketClient | null = null
let socketState: SocketState = 'disconnected'

const socketMiddleware = (store: MiddlewareStore) => (next: NextFn<SocketAction>) => (action: SocketAction) => {
  const actionType = action.type || ''
  const { loggedIn } = selectLoggedIn(store.getState())
  if (
    ![
      actionTypes.CONNECTION.SOCKET.CONNECTED,
      actionTypes.CONNECTION.SOCKET.CONNECTING,
      actionTypes.CONNECTION.SOCKET.DISCONNECTED,
    ].includes(actionType) &&
    loggedIn &&
    socketState === 'disconnected'
  ) {
    socketState = 'connecting'
    store.dispatch(socketConnecting())
    socket = io({
      path: '/gt-websocket/socket.io',
      reconnection: false,
    }) as unknown as SocketClient
    socket.on('connect', () => {
      socketState = 'connected'
      store.dispatch(socketConnected())
    })
    socket.on('disconnect', () => {
      socketState = 'disconnected'
      store.dispatch(socketDisconnected())
    })
    socket.on('connect_error', () => {
      socketState = 'disconnected'
      store.dispatch(socketDisconnected())
    })
    socket.on('notification', (data: unknown) => {
      store.dispatch(data)
    })
  }
  if (
    actionType !== actionTypes.CONNECTION.SOCKET.DISCONNECTED &&
    !loggedIn &&
    socketState !== 'disconnected'
  ) {
    socket?.disconnect()
  }
  return next(action)
}

export default socketMiddleware
